//const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';
import { isDev, isLocal } from './config';

export const getApiUrl = (endpoint: string): string => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;

  // Use Azure API if not running locally
  //const isLocal = window.location.hostname.includes('localhost');
  // const baseUrl = isLocal
  //   ? ''
  //   : (import.meta.env.VITE_API_BASE_URL || 'https://app-hearingtest.azurewebsites.net');

  const baseUrl = isLocal
    ? ''
    : isDev
      ? (import.meta.env.VITE_API_BASE_URL_DEV || 'https://app-hearingtest-dev.azurewebsites.net')
      : (import.meta.env.VITE_API_BASE_URL || 'https://app-hearingtest.azurewebsites.net');

  return `${baseUrl}/api/${cleanEndpoint}`;
};

